import React, { ReactNode, useEffect, useState } from "react";
import { useSideBar } from "hooks/useSidebar";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography } from "./components/Typography";
import { SidebarFooter } from "./components/SidebarFooter";
import {
  GroupsMenu,
  SidebarMain,
  StyledLogo,
  WrapperSidebar,
  menuItemStyles,
  themes,
} from "./styles/stylesSidebar";
import { CircularProgress, Icon, Tooltip } from "@material-ui/core";
import { useSubscription, useUserInfo } from "store/auth/auth-store";
import { NavLink, useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";

import Modal from "components/Modals/Modal/Modal";
import useLogin from "hooks/useLogin";
import {
  useDrawerOpen,
  useDrawerReporteOpen,
} from "store/user-settings/user-settings-store";

import { useLocation } from "react-router-dom";
import {
  // Avatar,
  // Category,
  // InsertChart,
  Portrait,
  ExitToApp,
  Cached,
  Settings,
  BugReport,
  BarChart,
  LockReset,
  AdminPanelSettings,
  NewReleases,
  Description,
} from "@mui/icons-material";

import keycloakConfig from "configs/keycloak";

// import { Dashboard } from "views/PowerBi";
import { useExternalDashboards } from "services/input-core/power-bi/get-external-dashboards";
import { SidebarHeader } from "./components/SidebarHeader";
import useHasRole from "hooks/useHasRole";

interface ISidebarProps {
  propsRoutes: any;
  logo: any;
  logoText: any;
  logoStratesys: any;
  logoStratesysMini: any;
  children: ReactNode;
}

// interface Category {
//   order: number;
//   title: string;
//   roles?: string[];
//   dashboards: Dashboard[];
// }

const apiUrl = `${process.env.REACT_APP_API_AUTH}/auth/realms/${process.env.REACT_APP_API_AUTH_REALM}/login-actions/reset-credentials?client_id=uverify&tab_id=5t-dvOHsHnM`;

const SidebarPro: React.FC = ({
  children,
  propsRoutes,
  logo,
  logoText,
  logoStratesys,
  logoStratesysMini,
}: ISidebarProps) => {
  const { t } = useTranslation("sidebar");
  const location = useLocation();
  const navigate = useNavigate();
  const { hasRealmRole } = useHasRole();

  const [openConfirmModal, setOpenConfirmModal] = useState(null);

  const { logout } = useLogin();

  const { drawerOpen, setDrawerOpen } = useDrawerOpen();
  const { drawerReporteOpen, setDrawerReporteOpen } = useDrawerReporteOpen();

  const {
    subscription,
    setSubscription,
    subscriptionsAvailable,
  } = useSubscription();

  const isStratesysUser = keycloakConfig.hasRealmRole("stratesys");

  const {
    collapsed,
    toggled,
    rtl,
    hasImage,
    theme,
    setToggled,
    setBroken,
    setRtl,
    avatar,
    routes,
    subscriptionName,
    setRoutes,
    isCreateReleaseNotes,
    isDocumentation,
    isNewHeaderUVerify,
  } = useSideBar();

  const { userInfo, setUserInfo } = useUserInfo();

  const { keycloak } = useKeycloak();

  // const {
  //   data: externalDashboards,
  //   isLoading: isLoadingExternalDashboards,
  // } = useExternalDashboards(subscription?.subscriptionId);

  useEffect(() => {
    if (userInfo) return;

    keycloak.loadUserInfo().then(() => {
      setUserInfo(keycloak.userInfo);
    });
  }, [userInfo]);

  useEffect(() => {
    propsRoutes && setRoutes(propsRoutes);
  }, [propsRoutes]);

  const handleOpenConfirmModal = () => {
    setOpenConfirmModal(
      <Modal onConfirm={logout} onDenied={hideConfirmModal} />,
    );
  };

  const hideConfirmModal = () => {
    setOpenConfirmModal(null);
  };

  return (
    <WrapperSidebar
      rtl={rtl}
      backgroundScroll={themes[theme].sidebar.backgroundColor}
    >
      {openConfirmModal}

      <Sidebar
        className="sidebar"
        collapsed={collapsed}
        toggled={toggled}
        onBackdropClick={() => setToggled(false)}
        onBreakPoint={(broken) => {
          setBroken(broken);
          setRtl(broken);
        }}
        width={rtl ? "300px" : "270px"}
        customBreakPoint="959px"
        rtl={rtl}
        backgroundColor={`transparent`}
        rootStyles={{
          background: `linear-gradient(195deg, ${themes[theme].sidebar.gradientIn}, ${themes[theme].sidebar.gradientOut}) !important`,
          color: themes[theme].sidebar.color,
          // zIndex: "1200 !important",
        }}
      >
        <GroupsMenu collapsed={collapsed}>
          <SidebarHeader
            logo={logo}
            logoText={logoText}
            rtl={rtl}
            style={{
              marginTop: "1rem",
              display: isNewHeaderUVerify ? "none" : "initial",
            }}
          />

          <SidebarMain>
            <>
              <div className="groupTitle">
                <Typography
                  variant="body2"
                  fontWeight={600}
                  style={{
                    opacity: collapsed ? 0 : 0.7,
                    letterSpacing: "0.5px",
                  }}
                >
                  {t("sections")}
                </Typography>
              </div>

              <Menu menuItemStyles={menuItemStyles(theme, collapsed, hasImage)}>
                {routes.map((route: any, index: number) => {
                  if (!route.invisible) {
                    if (route.redirect) {
                      return null;
                    }

                    // if (route.feature === "externalDashboard") {
                    //   return (
                    //     <SubMenu
                    //       label={t("external-dashboard")}
                    //       icon={<BarChart className={"itemIcon"} />}
                    //     >
                    //       {isLoadingExternalDashboards ? (
                    //         <CircularProgress
                    //           color="inherit"
                    //           size={50}
                    //           style={{ margin: "1.24rem 40%" }}
                    //         />
                    //       ) : (
                    //         externalDashboards?.map((category, index) => (
                    //           <MenuItem
                    //             key={index}
                    //             onClick={() =>
                    //               navigate("/app/external-dashboard", {
                    //                 state: { dashboards: category.dashboards },
                    //               })
                    //             }
                    //           >
                    //             <div
                    //               style={{
                    //                 display: "flex",
                    //                 alignItems: "center",
                    //                 justifyContent: rtl
                    //                   ? "flex-end"
                    //                   : "flex-start",
                    //                 flexDirection: rtl ? "row-reverse" : "row",
                    //                 gap: "1rem",
                    //               }}
                    //             >
                    //               <span>{category.title}</span>
                    //             </div>
                    //           </MenuItem>
                    //         ))
                    //       )}
                    //     </SubMenu>
                    //   );
                    // }

                    return (
                      <Tooltip
                        title={collapsed ? t(route.name) : ""}
                        key={index}
                        placement="right"
                      >
                        <MenuItem
                          icon={
                            route.icon !== undefined ? (
                              typeof route.icon === "string" ? (
                                <Icon className={"itemIcon"}>{route.icon}</Icon>
                              ) : (
                                <route.icon className={"itemIcon"} />
                              )
                            ) : (
                              <StyledLogo>
                                {rtl ? t(route.rtlMini) : t(route.mini)}
                              </StyledLogo>
                            )
                          }
                          component={
                            <NavLink
                              to={route.layout + route.path}
                              onClick={() => toggled && setToggled(() => false)}
                            />
                          }
                        >
                          {t(route.name)}
                        </MenuItem>
                      </Tooltip>
                    );
                  }
                })}
              </Menu>
            </>

            <>
              <div className="groupTitle">
                <Typography
                  variant="body2"
                  fontWeight={600}
                  style={{
                    opacity: collapsed ? 0 : 0.7,
                    letterSpacing: "0.5px",
                  }}
                >
                  {t("profile")}
                </Typography>
              </div>

              <Menu
                closeOnClick
                menuItemStyles={menuItemStyles(theme, collapsed, hasImage)}
              >
                <SubMenu
                  icon={
                    <div className={"photo"}>
                      <img
                        src={avatar}
                        className={"avatarImg"}
                        alt="avatar-photo"
                      />
                    </div>
                  }
                  label={
                    !userInfo?.name ? (
                      <CircularProgress size="16px" />
                    ) : (
                      <span
                        style={{
                          textTransform: "capitalize",
                          marginLeft: "0.5rem",
                        }}
                      >
                        {userInfo?.name}
                      </span>
                    )
                  }
                >
                  <MenuItem
                    icon={<Portrait className={"itemIcon"} />}
                    component={
                      <NavLink
                        to={"/app/profile"}
                        onClick={() => toggled && setToggled(() => false)}
                      />
                    }
                  >
                    {t("profile")}
                  </MenuItem>
                  <MenuItem
                    icon={<LockReset className={"itemIcon"} />}
                    component={
                      <NavLink
                        to={`/reset/${localStorage.getItem("accessToken")}`}
                        onClick={() => toggled && setToggled(() => false)}
                      />
                    }
                  >
                    {t("change-password")}
                  </MenuItem>
                  <MenuItem
                    icon={<Settings className={"itemIcon"} />}
                    component={
                      <div
                        onClick={() => {
                          toggled && setToggled(() => false);
                          setDrawerOpen(!drawerOpen);
                        }}
                      />
                    }
                  >
                    {t("configurations")}
                  </MenuItem>
                  {hasRealmRole(["Bug Reporter"]) && (
                    <MenuItem
                      icon={<BugReport className={"itemIcon"} />}
                      component={
                        <div
                          onClick={() => {
                            toggled && setToggled(() => false);
                            setDrawerReporteOpen(!drawerReporteOpen);
                          }}
                        />
                      }
                    >
                      {t("opening-calls")}
                    </MenuItem>
                  )}
                  <MenuItem
                    icon={<ExitToApp className={"itemIcon"} />}
                    component={
                      <div
                        onClick={() => {
                          toggled && setToggled(() => false);
                          handleOpenConfirmModal();
                        }}
                      />
                    }
                  >
                    {t("logout")}
                  </MenuItem>
                </SubMenu>

                {subscriptionsAvailable.length > 1 && (
                  <SubMenu
                    label={subscriptionName}
                    icon={<Cached className={"itemIcon"} />}
                  >
                    {subscriptionsAvailable.map((role, index) => (
                      <MenuItem
                        component={
                          <div
                            onClick={() => {
                              setSubscription(index);
                              navigate(location.search || location.pathname);
                            }}
                          />
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: rtl ? "flex-end" : "flex-start",
                            flexDirection: rtl ? "row-reverse" : "row",
                            gap: "1rem",
                          }}
                        >
                          <span>{role.mini}</span>
                          <span>{role?.name}</span>
                        </div>
                      </MenuItem>
                    ))}
                  </SubMenu>
                )}

                {isStratesysUser && (
                  <SubMenu
                    label={t("administrative-area")}
                    icon={<AdminPanelSettings className={"itemIcon"} />}
                  >
                    {isCreateReleaseNotes && (
                      <MenuItem
                        icon={<NewReleases className={"itemIcon"} />}
                        component={
                          <NavLink
                            to={"/app/release-notes"}
                            onClick={() => toggled && setToggled(() => false)}
                          />
                        }
                      >
                        {t("release-notes")}
                      </MenuItem>
                    )}

                    {isDocumentation && (
                      <MenuItem
                        icon={<Description className={"itemIcon"} />}
                        component={
                          <NavLink
                            to={"/app/documentation"}
                            onClick={() => toggled && setToggled(() => false)}
                          />
                        }
                      >
                        {t("documentation")}
                      </MenuItem>
                    )}
                  </SubMenu>
                )}
              </Menu>
            </>
          </SidebarMain>
          <SidebarFooter
            collapsed={collapsed}
            stratesys={logoStratesys}
            stratesysMini={logoStratesysMini}
          />
        </GroupsMenu>
      </Sidebar>

      {children}
    </WrapperSidebar>
  );
};

export default SidebarPro;
